// src/utils/categories.js
export const categories = [
    { name: '熱門文章', link: '/popularNews' },
    { name: '最新文章', link: '/latestNews' },
    { name: '分類文章', link: '/newsAll' }
];